import { Block, Icon, List, ListItem, Page, Popup } from "framework7-react";
import PopupNavbar from "../components/popup-navbar";
import { usePopupBackClose } from "../hooks/use-back-close";

const sameId = (a, b) => a != null && b != null && Number(a) === Number(b);

const PersonPickerPopup = ({
  className = "",
  title,
  opened,
  onClose,
  onSelect,
  participants = [],
  selectedId,
  disabledId,
  disabledHint,
  intro,
  children,
}) => {
  const backClose = usePopupBackClose(opened);
  return (
    <Popup
      {...backClose}
      className={`person-picker-popup ${className}`.trim()}
      opened={opened}
      onPopupClosed={onClose}
    >
      <Page>
        <PopupNavbar title={title} />
        {intro}
        <Block>
          <List strongIos dividersIos>
            {participants.map((participant) => {
              const disabled = sameId(participant.id, disabledId);
              return (
                <ListItem
                  key={participant.id}
                  title={participant.name}
                  link={!disabled}
                  disabled={disabled}
                  after={disabled ? disabledHint : undefined}
                  onClick={() => {
                    if (!disabled) onSelect(participant.id);
                  }}
                >
                  {sameId(participant.id, selectedId) && (
                    <Icon md="material:check" ios="f7:checkmark" slot="media" />
                  )}
                </ListItem>
              );
            })}
          </List>
        </Block>
        {children}
      </Page>
    </Popup>
  );
};

export default PersonPickerPopup;
